import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import { fetchIdentity, type CfAccessIdentity } from '../api/identity';

/**
 * TanStack Query wrapper around `fetchIdentity()`. Identity is per-session,
 * so we treat it as effectively immutable — infinite `staleTime` and no
 * background refetch.
 */
export function useIdentity(): UseQueryResult<CfAccessIdentity> {
    return useQuery({
        queryKey: ['cf-access-identity'],
        queryFn: fetchIdentity,
        staleTime: Infinity,
        refetchOnWindowFocus: false,
        retry: false,
    });
}
